import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import BaseMUIDataTable from './BaseMUIDataTable/BaseMUIDataTable';
import { getMuiTableDataIndex } from '../helpers/getters';

const UmbrellaFoodDonorStaffTable = ({ tableId, umbrellaFoodDonorStaff, customToolbar, actionButtons, umbrellaFoodDonorName }) => (
  <BaseMUIDataTable
    tableId={tableId}
    title="Staff"
    data={umbrellaFoodDonorStaff}
    columns={[
      {
        name: 'firstname',
        label: 'First Name',
        options: {
          filter: false,
          sort: false,
          display: true,
        },
      },
      {
        name: 'lastname',
        label: 'Last Name',
        options: {
          filter: false,
          sort: false,
          display: true,
        },
      },
      {
        name: 'email',
        label: 'Email',
        options: {
          filter: false,
          sort: false,
          display: true,
        },
      },
      {
        name: 'phone',
        label: 'Phone',
        options: {
          filter: false,
          sort: false,
          display: true,
        },
      },
      {
        name: 'is_admin',
        label: 'Role',
        options: {
          filter: true,
          sort: true,
          display: true,
          customBodyRender: value => (value ? 'Admin' : 'Staff'),
          customBodyRenderCSV: value => (value ? 'Admin' : 'Staff'),
        },
      },
      {
        name: 'completed_registration',
        label: 'Completed Registration',
        options: {
          filter: true,
          sort: true,
          display: true,
          customBodyRender: value => (value !== null ? 'yes' : 'no'),
          customBodyRenderCSV: value => (value !== null ? 'yes' : 'no'),
        },
      },
      {
        name: 'actions',
        label: 'Actions',
        options: {
          download: false,
          filter: false,
          sort: false,
          display: true,
          customBodyRender: (value, tableMeta) => {
            const staff = umbrellaFoodDonorStaff[getMuiTableDataIndex(tableMeta)];
            return actionButtons(staff);
          },
        },
      },
    ]}
    options={{
      responsive: 'simple',
      selectableRows: 'none',
      customToolbar: customToolbar,
      download: true,
      downloadOptions: {
        filename: umbrellaFoodDonorName 
          ? `${umbrellaFoodDonorName} Umbrella Donor Staff.csv`
          : 'Umbrella Donor Staff.csv',
      },
    }}
  />
);

UmbrellaFoodDonorStaffTable.propTypes = {
  tableId: PropTypes.string.isRequired,
  umbrellaFoodDonorStaff: PropTypes.array,
  customToolbar: PropTypes.func,
  actionButtons: PropTypes.func,
  umbrellaFoodDonorName: PropTypes.string,
};

export default UmbrellaFoodDonorStaffTable;
